import { Suspense } from "react"
import { useTranslation } from "react-i18next"

import { AppBreadcrumb } from "@/components/layout/app-breadcrumb"
import { DashboardContainer } from "@/components/layout/dashboard-container"
import { Header } from "@/components/layout/header"
import { SmartRoutingFilterForm } from "@/components/smart-routing/filter-form"
import { SmartRoutingTable } from "@/components/smart-routing/table"
import { FRONTEND_ROUTES } from "@/constants"

export function SmartRoutingPage() {
  const { t } = useTranslation()

  return (
    <Suspense fallback={<div>{t("common.loading")}</div>}>
      <DashboardContainer>
        <Header>
          <AppBreadcrumb
            links={[
              {
                href: FRONTEND_ROUTES.SMART_ROUTING.href,
                label: t("sidebar.smartRouting"),
              },
              {
                label: t("pages.smartRouting.title"),
              },
            ]}
          />
        </Header>
        <section className="flex flex-1 flex-col gap-4 overflow-x-hidden p-4 @container">
          <h1 className="page-title">
            {t("pages.smartRouting.title")}
          </h1>
          <SmartRoutingFilterForm />
          <SmartRoutingTable />
        </section>
      </DashboardContainer>
    </Suspense>
  )
}
